export const __SliderLang = {
    noData: 'داده ای موجود نیست',
};
